/* RAWS: trim the SEO keyword suffix ("... | PERFORMANCE RUNNING ACTIVEWEAR") from
   product titles shown on cards. It edits the rendered text only, so product.title
   is untouched and the Merchant Center feed, meta tags and search keep the full
   string. It trims the existing text node rather than re-rendering it, so the
   brand's A -> letterform swap in theme.liquid survives either run order. */
(function () {
  var SEL =
    '.product-card__title, .vertical-product-card__title, .horizontal-product-card__title';

  function trim(el) {
    if (!el || el.getAttribute('data-raws-trimmed')) return;
    el.setAttribute('data-raws-trimmed', '1');
    var text = el.textContent;
    if (text.indexOf('|') === -1) return;
    el.textContent = text.split('|')[0].trim();
  }

  function run(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll(SEL);
    for (var i = 0; i < nodes.length; i++) trim(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      run();
    });
  } else {
    run();
  }

  /* Collection filtering, infinite scroll, quick view and the cart drawer all
     inject cards after load, so keep watching for new ones. */
  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches(SEL)) trim(node);
          run(node);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/* RAWS: "Shop by collection" cards on product pages use the same short names as
   the Shop All menu ("RAWS : [TRAINING]" -> "TRAINING",
   "RAWS : TERRAIN : TRAIL : SKI" -> "TERRAIN · TRAIL · SKI"). The menu does this
   in header.liquid; the theme's collection list section has no hook for it, so
   it is done here for that one section only. Handles the A -> letterform swap. */
(function () {
  var SEL = '.shopify-section[id$="__raws_collection_cards"] .collection-card__title';

  function tidy(el) {
    if (!el || el.getAttribute('data-raws-tidied')) return;
    el.setAttribute('data-raws-tidied', '1');
    var text = el.textContent
      .replace(/^\s*R[AʌɅ]WS\s*:\s*/i, '')
      .replace(/[\[\]]/g, '')
      .replace(/\s+:\s+/g, ' · ')
      .trim();
    if (text) el.textContent = text;
  }

  function run() {
    var nodes = document.querySelectorAll(SEL);
    for (var i = 0; i < nodes.length; i++) tidy(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  window.addEventListener('load', run);
})();

/* RAWS: the sticky header turns dark once it is pinned to the top of the window,
   and back to light when the page is scrolled to the top again. It swaps the
   header bar from the "Primary" colour scheme to the theme's dark "Custom 1"
   scheme (the footer's), so text, icons and the border all follow the theme's
   own colours. The logo turns white in raws-titles.css (section 6). The menu
   dropdowns carry their own colour scheme, so they stay light. If the header's
   colour scheme is changed in the theme editor away from Primary, this does
   nothing. */
(function () {
  var LIGHT = 'color-primary';
  var DARK = 'color-custom-1';
  var STUCK = 'raws-header-stuck';
  var section = null;
  var queued = false;

  function apply() {
    queued = false;
    if (!section || !section.isConnected) {
      section = document.querySelector('.shopify-section-header');
    }
    if (!section) return;
    /* Opening a mega menu, the cart or search locks the page (body gets
       "scroll-y-off" and a negative top) and scrollY reads 0 until it closes.
       Leave the header as it is until then, or it would flash back to light. */
    var body = document.body;
    if (body.classList.contains('scroll-y-off') || parseFloat(body.style.top) < 0) return;
    var stuck = window.scrollY > 0 && section.getBoundingClientRect().top <= 0.5;
    section.classList.toggle(STUCK, stuck);

    var header = section.querySelector('header-component.header');
    if (!header) return;
    if (stuck && header.classList.contains(LIGHT)) {
      header.classList.replace(LIGHT, DARK);
      header.setAttribute('data-raws-dark', '1');
    } else if (!stuck && header.hasAttribute('data-raws-dark')) {
      header.classList.replace(DARK, LIGHT);
      header.removeAttribute('data-raws-dark');
    }
  }

  function queue() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(apply);
  }

  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  window.addEventListener('load', queue);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();
